/* eslint-disable react/no-danger */
import { Glyphicon } from '@bingads-webui-react/primitive';
import React from 'react';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import type { DefaultStyleClasses } from '@bingads-webui-react/with-default-styles';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';

import {
  FloatingBannerMessageWrapperProps,
  INotification,
  NotificationI18n,
  NotificationLevel,
} from '../types';
import { styles } from './styles';

// We have this Wrapper because currently in CMUI we might shown fallback callout for some link
// Once there's no need to do that, we could move this part into UnstyledFloatingBanner
class DefaultWrapper extends React.PureComponent<FloatingBannerMessageWrapperProps> {
  render() {
    return (
      React.isValidElement(this.props.notification.message)
        ? (
          <span
            className={this.props.messageClassName}
            role="alert"
          >
            {this.props.notification.message}
          </span>
        )
        : (
          <span
            className={this.props.messageClassName}
            dangerouslySetInnerHTML={{ __html: this.props.notification.message }}
            role="alert"
          />
        )
    );
  }
}

export interface IFloatingBannerBarProps {
  notification: INotification;
  i18n: NotificationI18n;
  dismiss: () => void;
  classes: DefaultStyleClasses;
  Wrapper?: React.ComponentType<FloatingBannerMessageWrapperProps>;
}

// eslint-disable-next-line react/no-multi-comp
class UnstyledFloatingBannerBar extends React.PureComponent<IFloatingBannerBarProps> {
  static defaultProps = {
    Wrapper: DefaultWrapper,
  };

  componentDidMount() {
    // Focus the dismiss button when the banner appears
    if (this.exitIconRef.current) {
      this.exitIconRef.current.focus();
    }
  }

  private exitIconRef = React.createRef<HTMLDivElement>();

  render() {
    const {
      classes, notification, i18n, dismiss, Wrapper,
    } = this.props;

    const wrappedMsg = <Wrapper notification={notification} messageClassName={classes.text} i18n={i18n} />;

    const ExitIcon = (
      <div
        ref={this.exitIconRef}
        tabIndex={0}
        role="button"
        aria-label={i18n.getString(_TL_('Dismiss the message'))}
        onClick={() => dismiss()}
        onKeyDown={submitEvent(dismiss)}
        className={classNames('exitIcon', classes.exitIcon)}
      >
        <Glyphicon
          glyph="ba-Cancel"
        />
      </div>
    );

    if (notification.severity === NotificationLevel.Info) {
      return (
        <div className={classNames('floating-banner', 'infoFloatingBanner', classes.infoFloatingBanner)}>
          <Glyphicon className={classes.infoIcon} glyph="ba-Completed" />
          {wrappedMsg}
          {ExitIcon}
        </div>
      );
    } if (notification.severity === NotificationLevel.Warning) {
      return (
        <div className={classNames('floating-banner', 'warnFloatingBanner', classes.warnFloatingBanner)}>
          <Glyphicon className={classes.warnIcon} glyph="ba-Warning" />
          {wrappedMsg}
          {ExitIcon}
        </div>
      );
    }
    return null;
  }
}

export const FloatingBannerBar = withDefaultStyles(UnstyledFloatingBannerBar, styles);
